function diffuser_oil_parse_json(str, fallback){
	if ( !str ) { return fallback; }
	try {
		var parsed = JSON.parse(str);
		return ( parsed === null || parsed === undefined ) ? fallback : parsed;
	} catch (e) {
		console.error('vue-diffuser-oil.js: failed to parse', str, e);
		return fallback;
	}
}

var diffuser_oil_el = document.getElementById('diffuser-oil-subscribe');
var diffuser_oil_variant_id = diffuser_oil_el ? diffuser_oil_parse_json(diffuser_oil_el.dataset.variantId, null) : null;
var diffuser_oil_variant_price_cents = diffuser_oil_el ? parseInt(diffuser_oil_el.dataset.variantPrice, 10) || 0 : 0;
// .price/.compare_at_price on each allocation are precomputed by Shopify in cents, same as
// variant.price — unlike selling_plan.price_adjustments[].value, whose unit isn't consistently
// documented, so we deliberately read the allocation's resolved price instead of the raw adjustment.
var diffuser_oil_selling_plan_allocations = diffuser_oil_el ? diffuser_oil_parse_json(diffuser_oil_el.dataset.sellingPlanAllocations, []) : [];

var vue_diffuser_oil = diffuser_oil_el ? new Vue({
	el: diffuser_oil_el,
	delimiters: ['[[',']]'],
	data: {
		purchase_option: diffuser_oil_selling_plan_allocations.length ? 'subscription' : 'onetime',
		selected_selling_plan_id: diffuser_oil_selling_plan_allocations.length ? diffuser_oil_selling_plan_allocations[0].selling_plan.id : null,
		selling_plan_allocations: diffuser_oil_selling_plan_allocations,
		variant_price_cents: diffuser_oil_variant_price_cents
	},
	computed: {
		selected_allocation: function(){
			var scope = this;
			return this.selling_plan_allocations.find(function(a){ return a.selling_plan.id == scope.selected_selling_plan_id; });
		},
		display_price_cents: function(){
			if ( this.purchase_option == 'subscription' && this.selected_allocation ) {
				return this.selected_allocation.price;
			}
			return this.variant_price_cents;
		},
		button_label: function(){
			var verb = this.purchase_option == 'subscription' ? 'Subscribe' : 'Add to Cart';
			return verb + ' — ' + this.format_money(this.display_price_cents);
		}
	},
	methods: {
		format_money: function(amt){
			return slate.Currency.formatMoney(amt).replace('.00', '');
		},
		add_to_cart: function(){
			window.track_add();

			var item = {
				id: diffuser_oil_variant_id,
				quantity: 1
			};
			if ( this.purchase_option == 'subscription' && this.selected_selling_plan_id ) {
				item.selling_plan = this.selected_selling_plan_id;
			}

			// route through the same #json_cart_field -> /cart/add.js bridge the diffuser
			// builder uses — NOT the #productform submit handler, which only ever reads
			// plain id/id[] fields and can't carry a selling_plan safely (see vue-cart.js)
			var json_cart_field = $('#json_cart_field');
			json_cart_field.val(JSON.stringify([item]));
			json_cart_field.trigger('change');
		}
	}
}) : null;

